import {toast} from "react-toastify"
async function loadBuild(url, requestOptions) {
    const notify_success = () => {
      toast.success("Selected orders are marked for load successfully");
    };
  
    await fetch(url, requestOptions).then((response) => {
      if (response["status"] == 200) {
        notify_success();
      } else if (response["status"] == 409) {
        toast.warn("Error Occurred");
      } else {
        toast.error("Load Build failed");
      }
    });
  }

  export default loadBuild;